import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolListComponent } from 'src/app/component/tools/tool-list/tool-list.component';
import { DynamicComponentDirective } from 'src/app/directive/dynamicComponent/dynamic-component.directive';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { JobPointeService } from 'src/app/service/job-pointe/job-pointe.service';

@Component({
  selector: 'app-job-pointe-settings-table',
  templateUrl: './job-pointe-settings-table.component.html',
  styleUrls: ['./job-pointe-settings-table.component.scss'],
})
export class JobPointeSettingsTableComponent implements OnInit {
  @Input() headers: any; // column headers for table
  @Input() rows: any; // row data to display in table
  @Input() totalItems: any;
  @Input() getData: any;
  @Input() sortData: string; // data indicating column
  @Input() selected?: Array<any>;
  @Input() meta: any;
  @Input() source: string;
  @Output() action = new EventEmitter<any>();
  @Output() selectedChange: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();
  @Output() selectedAdd = new EventEmitter<any>();
  @Output() selectedRemove = new EventEmitter<any>();
  @Output() selectedAll = new EventEmitter<any>();
  @Output() refreshSelectAll = new EventEmitter<any>();
  @Output() removeAll = new EventEmitter<any>();

  subscription: Subscription;
  filersClearedSubscription: Subscription;
  deselectAll: Boolean;

  @ViewChild(DynamicComponentDirective)
  dynamicComponent: DynamicComponentDirective;

  sort: any = { name: '', direction: '' };
  sortDirection: any = { asc: 'desc', desc: 'asc' }; // used as a toggle to switch between asc and desc order
  defaultDirection: string = 'asc';

  constructor(
    private toolList: ToolListComponent,
    private loaderService: LoaderService,
    private toastService: ToastService,
    private jobpointeService: JobPointeService,
  ) { }

  ngOnInit(): void {
    const [field, direction] = this.sortData?.split(',') || ['', ''];
    this.sort.name = field;
    this.sort.direction = direction;

    this.toolList.refreshAll.subscribe(res => {
      if (!Object.keys(res).length || !res.data) {
        return;
      }
      if (res.data.length === this.totalItems) {
        if (!this.deselectAll) {
          this.selected = [...res.data.map(row => row.id)];
          this.selectedAll.emit(res.data);
          this.selectedChange.emit(this.selected);
        } else {
          this.selected = [];
          this.removeAll.emit(res.data);
          this.selectedChange.emit(this.selected);
        }
        if (res.data.length > 50) this.refreshSelectAll.emit(50);
        this.loaderService.hideLoader();
      }
    });

    this.filersClearedSubscription = this.jobpointeService.filtersCleared.subscribe(res => {
      if (res.filterType) {
        this.sort.name = '';
        this.sort.direction = '';
      }
    });
  }

  ngOnDestroy(): void {
    this.filersClearedSubscription.unsubscribe();
  }

  triggerAction(action: string, payload, actionPayload?: any) {
    if (action === 'sort') {
      if (this.sort.name === payload) {
        this.sort.direction = this.sortDirection[this.sort.direction] || this.defaultDirection;
      } else {
        this.sort.name = payload;
        this.sort.direction = this.defaultDirection;
      }
      payload = `${this.sort.name},${this.sort.direction}`;
    }
    const actionData = { action, payload, actionPayload, source: this.source };
    this.action.emit(actionData);
  }

  printRowData(property, row, defaultValue = ''): string {
    if (typeof property === 'function') {
      return property(row);
    }
    return row[property] ? row[property] : defaultValue;
  }

  handleSelectAll(event: any) {
    if (event.target.checked) {
      this.selectedAll.emit(this.rows);
      return
    }

    this.removeAll.emit();
  }

  handleCheckbox(event, row = undefined): void {
    if (!event.target.checked) {
      // remove value, if  unchecked
      this.selected.splice(this.selected.indexOf(row), 1);
      this.selectedChange.emit(this.selected);
      return;
    }

    // push new value onto list, if checked
    this.selected.push(row);
    this.selectedChange.emit(this.selected);
    this.selectedAdd.emit(row);
  }

  async handleJobBoardCheckbox(event): Promise<void> {
    this.loaderService.displayLoader();

    const payload = {
      user_id: event.target.value,
      is_on_job_board: event.target.checked,
    };

    this.jobpointeService.update['employees'](payload).subscribe(
      res => {
        this.loaderService.hideLoader();
        this.getData();
      },
      err => {
        this.loaderService.hideLoader();
        this.toastService.showToast('Error in updating employee job board status', 'error');
        event.target.checked = false;
        console.error('error:', err);
      },
    );
  }

  // If there's a show attribute on the column object, infer UI based on that, otherwise show it.
  isViewable = column => {
    if (typeof column?.show === 'function') {
      return column.show();
    }
    return true;
  };
}
